import { Classes } from '@blueprintjs/core';
import React, { Component } from 'react';
import { Redirect, Route, Switch as RouterSwitch } from 'react-router-dom';
import HeaderComponent from './headerComponent';
import ExceptionsContainer from './Houston/exceptionsView/exceptionsContainer';
import LateTripsContainer from './Houston/lateTripsView/lateTripsContainer';
import OpenTripsContainer from './Houston/openTripsView/openTripsContainer';
import ProvidersContainer from './Houston/providersView/providersContainer';
import TripSearchContainer from './Houston/tripSearchView/tripSearchContainer';

const DARK_THEME = Classes.DARK
const LIGHT_THEME = ''

class NavContainer extends Component {

  constructor(props) {
    super(props);

    const themeName = localStorage.getItem("themeName");

    this.state = {
      themeName: themeName,
      useLightTheme: themeName === DARK_THEME ? false : true,
      mainContainerStyle: {
        backgroundColor: themeName === DARK_THEME ? 'rgb(48, 64, 77)' : '',
        flexDirection: 'column',
        display: 'inline-table',
        height: '115%',
        width: 'auto',
        minHeight: '115%',
        minWidth: '100%',
        position: 'absolute',
        contain: 'inherit'
      },
      headerPath: [
        { icon: 'folder-close', text: 'Home' },
        { icon: 'folder-close', text: 'Houston' }
      ]
    };
  }

  handleToggleDark = (e) => {
    if (e.currentTarget.checked === true) {
      this.setState({
        useLightTheme: true,
        themeName: LIGHT_THEME,
        mainContainerStyle: {
          backgroundColor: '',
          flexDirection: 'column',
          display: 'inline-table',
          height: '115%',
          width: 'auto',
          minHeight: '115%',
          minWidth: '100%',
          position: 'absolute',
          contain: 'inherit'
        }
      })
    } else {
      this.setState({
        useLightTheme: false,
        themeName: DARK_THEME,
        mainContainerStyle: {
          backgroundColor: 'rgb(48, 64, 77)',
          flexDirection: 'column',
          display: 'inline-table',
          height: '115%',
          width: 'auto',
          minHeight: '115%',
          minWidth: '100%',
          position: 'absolute',
          contain: 'inherit'
        }
      })
    }
  }

  handleHeaderPathChange = (text) => {
    const actualPath = { text: text };
    const headerPath = this.state.headerPath;
    headerPath.splice(2, 1, actualPath);
  }

  render() {
    localStorage.setItem("themeName", this.state.themeName);
    return (
      <div id='mainContainer' className={this.state.themeName} style={this.state.mainContainerStyle}>
        <HeaderComponent headerPath={this.state.headerPath} useLightTheme={this.state.useLightTheme} themeName={this.state.themeName} handleToggleDark={this.handleToggleDark} />
        <RouterSwitch>
          <Route path="/exceptions" component={() => <ExceptionsContainer themeName={this.state.themeName} handleHeaderPathChange={this.handleHeaderPathChange} />} />
          <Route path="/opentrips" component={() => <OpenTripsContainer themeName={this.state.themeName} handleHeaderPathChange={this.handleHeaderPathChange} />} />
          <Route path="/latetrips" component={() => <LateTripsContainer themeName={this.state.themeName} handleHeaderPathChange={this.handleHeaderPathChange} />} />
          <Route path="/provider" component={() => <ProvidersContainer themeName={this.state.themeName} handleHeaderPathChange={this.handleHeaderPathChange} />} />
          <Route path="/tripsearch" component={() => <TripSearchContainer themeName={this.state.themeName} handleHeaderPathChange={this.handleHeaderPathChange} />} />
          <Redirect to="/exceptions" />
        </RouterSwitch>
      </div>
    )
  }

  handleOpen = () => this.setState({ isOpen: true });
  handleClose = () => this.setState({ isOpen: false });
}

export default NavContainer;
